import { render, staticRenderFns } from "./TextareaDefault.vue?vue&type=template&id=2dc16e7a"
import script from "./TextareaDefault.vue?vue&type=script&lang=js"
export * from "./TextareaDefault.vue?vue&type=script&lang=js"
import style0 from "./TextareaDefault.vue?vue&type=style&index=0&id=2dc16e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports